var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTerrace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    "data-name": "IconTerrace",
    preserveAspectRatio: "xMidYMid meet",
    theme: "[object Object]",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.095 4.726c.152.17.152.436 0 .588l-.683.664a.418.418 0 01-.284.114.418.418 0 01-.285-.114c-.151-.17-.151-.436 0-.588l.664-.664c.17-.152.436-.152.588 0zm.873.626c.17-.152.436-.152.588 0a.418.418 0 01-.02.588L9.039 7.438a.386.386 0 01-.284.114.418.418 0 01-.285-.114c-.152-.17-.152-.436 0-.588l1.499-1.498z",
    fill: "#023E8A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.61 2.85a.66.66 0 00-.662.662v9.77H4.012a.66.66 0 00-.662.662.66.66 0 00.662.662H5v5.22h-.988a.66.66 0 00-.662.662.66.66 0 00.662.662h16.463a.66.66 0 00.662-.662.656.656 0 00-.662-.643h-.988v-5.22h.988a.66.66 0 00.662-.662.66.66 0 00-.662-.662H18.54V3.512a.66.66 0 00-.662-.662H6.61zm.662 10.432V4.174h4.31v9.108h-4.31zm5.634.02V4.173h4.309v9.127h-4.31zm-6.582 6.543v-5.22h1.957v5.22H6.324zm3.3 0v-5.22h1.957v5.22H9.624zm3.282 0v-5.22h1.957v5.22h-1.957zm3.3 0v-5.22h1.957v5.22h-1.957z",
    fill: "#023E8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerrace);
export default __webpack_public_path__ + "static/media/Terrace.15ed7f676ed2935df7a04ea8eec25da8.svg";
export { ForwardRef as ReactComponent };